export function Header({ children }) {
  return <header>{children}</header>;
}
